module.exports = __webpack_public_path__ + "static/media/Gabriel.12db0d4c.jpg";